/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_User_CountInputs */

const en_tables_skill_groups_user_count = /** @type {(inputs: Tables_Skill_Groups_User_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups User Count`)
};

const de_tables_skill_groups_user_count = /** @type {(inputs: Tables_Skill_Groups_User_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Benutzer`)
};

/**
* | output |
* | --- |
* | "Groups User Count" |
*
* @param {Tables_Skill_Groups_User_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_user_count = /** @type {((inputs?: Tables_Skill_Groups_User_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_User_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_user_count(inputs)
	return de_tables_skill_groups_user_count(inputs)
});